module.exports = __webpack_public_path__ + "img/img_more_btn.0c967319.png";